// Fetch Request
import fetch from '../../../core/fetch';
// Redux
import { closeListSettingsModal } from '../../../actions/siteadmin/modalActions';
import { getAdminListingSettings } from '../../../actions/siteadmin/getAdminListingSettings';
import showToaster from '../../../helpers/toasterMessages/showToaster';

async function update(values, dispatch) {
  // DEBUG: Log all values being sent to mutation
  console.log('🚀 [ListSettings UPDATE] Datos enviados:', JSON.stringify(values, null, 2));
  console.log('🔍 [ListSettings UPDATE] Campos de idioma:', {
    itemName_en: values.itemName_en,
    itemName_fr: values.itemName_fr,
    itemDescription_en: values.itemDescription_en,
  });

  const query = `
    query (
        $id:Int,
        $typeId:Int,
        $itemName:String,
        $itemName_en:String,
        $itemName_fr:String,
        $itemName_it:String,
        $itemName_pt:String,
        $itemDescription:String,
        $itemDescription_en:String,
        $itemDescription_fr:String,
        $itemDescription_it:String,
        $itemDescription_pt:String,
        $otherItemName:String,
        $otherItemName_en:String,
        $otherItemName_fr:String,
        $otherItemName_it:String,
        $otherItemName_pt:String,
        $maximum:Int,
        $minimum:Int,
      	$startValue:Int,
        $endValue:Int,
        $isEnable: String,
        $makeType: String
      ) {
          updateListSettings (
            id: $id,
            typeId:$typeId,
            itemName:$itemName,
            itemName_en:$itemName_en,
            itemName_fr:$itemName_fr,
            itemName_it:$itemName_it,
            itemName_pt:$itemName_pt,
            itemDescription:$itemDescription,
            itemDescription_en:$itemDescription_en,
            itemDescription_fr:$itemDescription_fr,
            itemDescription_it:$itemDescription_it,
            itemDescription_pt:$itemDescription_pt,
            otherItemName: $otherItemName,
            otherItemName_en: $otherItemName_en,
            otherItemName_fr: $otherItemName_fr,
            otherItemName_it: $otherItemName_it,
            otherItemName_pt: $otherItemName_pt,
            maximum: $maximum,
            minimum: $minimum,
            startValue: $startValue,
            endValue: $endValue,
            isEnable: $isEnable,
            makeType: $makeType
          ) {
            status
          }
        }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateListSettings?.status === "success") {
    dispatch(closeListSettingsModal());
    await dispatch(getAdminListingSettings(values.typeId));
    showToaster({ messageId: 'updateListSettings', toasterType: 'success' })
  } else if (data?.updateListSettings?.status === "unableToDisable") {
    showToaster({ messageId: 'checkActiveListing', toasterType: 'error' })
  } else if (data?.updateListSettings?.status === "listingUsed") {
    showToaster({ messageId: 'removeListSettings', toasterType: 'error' })
  } else if (data?.updateListSettings?.status === 'modelUsed') {
    showToaster({ messageId: 'removeModel', toasterType: 'error'})
  } else {
    showToaster({ messageId: 'updateListSettings', toasterType: 'error' })
  }
  dispatch(closeListSettingsModal());

}

export default update;
